package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class HintDto(
    @SerialName("text") val text: String?,
    @SerialName("icon") val icon: String?,
)
